import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App.js";
import "./styles/tebiki.css";

// PWA auto-update: when an already-controlled page gets a new service worker (a fresh deploy,
// activated via skipWaiting+clientsClaim), reload once so users always run the latest build
// instead of a stale cached bundle. Guarded by an existing controller so first visits don't reload.
if ("serviceWorker" in navigator && navigator.serviceWorker.controller) {
  let reloading = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (reloading) return;
    reloading = true;
    window.location.reload();
  });
}

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
